import { images } from "../assets";
import React, { useState, useEffect } from "react";
import APIService from "../services/APIService";
import Heading from "../components/Heading";
import CategoryItem from "../components/items/CategoryItem";
import TopBanner from "../components/home/TopBanner";


export default function CategoryList() {
  const [listCategory, setListCategory] = useState(["", "", "", "", ""]);
  const [banner, setBanner] = useState({})

  async function getListBanner() {
    const RESULT = await APIService.getListBanner("category");
    if (RESULT) {
      setBanner(RESULT);
    }
  }
  async function getListCategory() {
    const RESULT = await APIService.getListCategory();
    if (RESULT) {
      setListCategory(RESULT);
    }
  }

  useEffect(() => {
    getListBanner()
    getListCategory();
  }, []);
  return (
    <div className="w-full">
      <TopBanner data={banner.banners} />
      <div className="h-8"></div>
      <Heading isShowButtonMore={false} title="Danh mục sản phẩm"></Heading>
      <div className="grid md:grid-cols-4 sm:grid-cols-3 grid-cols-2 sm:gap-[25px] gap-[10px] mt-4">
        {listCategory.map(item => (
          <CategoryItem
  
            data={item}
          />
        ))}
      </div>
    </div>
  );
}
